(ns renolit-roofing-service.util.file
  (:require [cljc.java-time.instant :as jt.instant]
            [clojure.string :as str]
            [goog.object :as g]
            [renolit-roofing-service.util :as util]))

(defn- new-js-file-reader-obj
  []
  (new js/FileReader))

(def ^:const allowed-csv-filetypes
  ["text/csv"])

(def ^:const allowed-image-filetypes
  ["image/png" "image/jpeg" "image/gif"
   "image/tiff" "image/svg+xml" "image/webp"])

(defn browser-file->file
  [browser-file]
  (let [type (g/get browser-file "type")
        size (g/get browser-file "size")
        last-modified-at (->> (g/get browser-file "lastModified")
                              (jt.instant/of-epoch-milli))
        [name extension] (-> (g/get browser-file "name")
                             (str/split #"\.(?!.*\.)"))]
    {:fe-id (random-uuid)
     :name name
     :type type
     :extension extension
     :size size
     :last-modified-at last-modified-at
     :content browser-file}))

(defn get-files-from-drag-event
  [event]
  (if-let [items (g/getValueByKeys event "dataTransfer" "items")]
    (->> items
         (filter #(= "file" (g/get % "kind")))
         (map #(.getAsFile %))
         (map browser-file->file))
    (->> (g/getValueByKeys event "dataTransfer" "files")
         (map browser-file->file))))

(defn get-files-from-input-on-change-event
  [event]
  (let [browser-files (g/getValueByKeys event "target" "files")]
    (map browser-file->file browser-files)))

(defn get-file-content-as-base64
  [file callback-fn]
  (let [reader (new-js-file-reader-obj)]
    (set! (.-onload reader) (fn [event]
                              (let [base64 (g/getValueByKeys event "target" "result")]
                                (callback-fn base64))))
    (.readAsDataURL reader (:content file))))

(defn humanize-file-size
  "https://www.geeksforgeeks.org/javascript-convert-bytes-to-human-readable-string/
  Note that the calculation is in base 10."
  [size-in-bytes]
  (some
   (fn [[i unit]]
     (when (< size-in-bytes (js/Math.pow 1000 (inc i)))
       (str
        (/ (js/Math.round (* (/ size-in-bytes (js/Math.pow 1000 i)) 100)) 100)
        " "
        unit)))
   (keep-indexed vector ["byte" "kB" "MB" "GB" "TB"])))

(defn open-file-picker
  [{:keys [on-change]}]
  (doto (js/document.createElement "input")
    (.setAttribute "type" "file")
    (.addEventListener "change" (comp (partial util/execute-callback on-change)
                                      get-files-from-input-on-change-event))
    (.click)))

(defn trigger-csv-download!
  [filename csv-text]
  (let [blob (js/Blob. #js [csv-text] #js {:type "text/csv;charset=utf-16le"})
        url  (.createObjectURL js/URL blob)
        a    (.createElement js/document "a")]
    (set! (.-href a) url)
    (set! (.-download a) filename)
    (.appendChild (.-body js/document) a)
    (.click a)
    (.remove a)
    (.revokeObjectURL js/URL url)))
